import React, { useContext, useEffect, useState } from "react";
import ReactPlayer from "react-player";
import Lock from "../../Assets/Images/Normal-User/lock.png";
import axios from "axios";
import {
  LocationContext,
  userPostPaymentCheck,
} from "../../CustomHelper/Helper";

import "../../components/CSS/Profile/starProfile/starVideos.css";
import StarProfileRightContent from "./StarCardComponent/StarProfileRightContent/StarProfileRightContent";
import PaymentModal from "../Modal/PaymentModal/PaymentModal";
import NodataAvailable from "../Common/NodataAvailable";
import { serverInfo } from "../../App";
import MyVerticallyCenteredModal from "../RegisterLearningDetails/RegisterNowPay/MyVerticallyCenteredModal";

function Videos({ star_id }) {
  const { videoCdnUrl } = useContext(serverInfo);

  const [post, setPost] = useState([]);

  const [successShow, setSuccessShow] = useState(false);
  const [post_id, setPostId] = useState(false);
  const [fee, setFee] = useState("");
  const [payment_status, setPaymentStatus] = useState([]);
  const [lockStatus, setLockStatus] = useState([]);
  const [videosUpdate, setUnlocked] = useState(false);
  const { paymentCount, paymentCountWithSymbol, payStatus } =
    useContext(LocationContext);

  const makePayment = (id) => {
    setPostId(id[0]);
    setFee(id[1]);
    setSuccessShow(true);
  };

  const getVideos = () => {
    axios.get(`api/star_videos/${star_id}`).then((res) => {
      if (res.data.status === 200) {
        setPost(res.data.post);
      }
    });
    axios.get(`api/user/generalPost/payment/check`).then((res) => {
      if (res.data.status === 200) {
        setLockStatus(res.data.lockStatus);
      }
    });
    setUnlocked(false);
  };

  useEffect(() => {
    getVideos();
  }, [videosUpdate]);

  return (
    // This full page mainly comes from star photos page
    <div className=" StarContainer">
      <div className="row">
        <div className="col-sm-12 col-lg-8 mt-3">
          <div className="card m-2 star-photos-card mx-auto pb-3">
            <div className="card-body">
              <h5 className="card-title text-warning">Videos</h5>
            </div>
            <div className="star-line"></div>

            <div className="card-body mb-2">
              <div className="row text-center">
                {/* <div className="col-4 play-button-container ">
                  <StarVideoDetails />
                </div> */}

                {post.length > 0 ? (
                  post.map((postVideo) => (
                    <>
                      {postVideo.type === "paid" ? (
                        <>
                          {postVideo.video ? (
                            <div className="col-4 mb-2 mt-2">
                              <div style={{ position: "relative" }}>
                                <div
                                  className={
                                    userPostPaymentCheck(
                                      postVideo.id,
                                      lockStatus
                                    ) === false
                                      ? "divDisable"
                                      : null
                                  }
                                >
                                  <ReactPlayer
                                    url={videoCdnUrl + postVideo.video}
                                    playing={false}
                                    controls={true}
                                    className="ImgBlur"
                                    volume={1}
                                    width="100%"
                                    height="100%" // style={{ margin: "0 auto" }}
                                  />
                                </div>
                                {userPostPaymentCheck(
                                  postVideo.id,
                                  lockStatus
                                ) === false ? (
                                  <img
                                    src={Lock}
                                    alt=""
                                    className="ImGCernterP"
                                    onClick={() =>
                                      makePayment([
                                        postVideo?.id,
                                        postVideo?.fee,
                                      ])
                                    }
                                  />
                                ) : null}
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}
                        </>
                      ) : (
                        <>
                          {postVideo.video ? (
                            <div className="col-4 mb-3">
                              <ReactPlayer
                                url={videoCdnUrl + postVideo.video}
                                playing={false}
                                controls={true}
                                volume={1}
                                width="100%"
                                height="100%" // style={{ margin: "0 auto" }}
                              />
                            </div>
                          ) : (
                            <></>
                          )}
                        </>
                      )}
                    </>
                  ))
                ) : (
                  <NodataAvailable className="mt-5" />
                )}
              </div>
            </div>

            <MyVerticallyCenteredModal
              show={successShow}
              onHide={() => setSuccessShow(false)}
              event_id={post_id}
              fee={paymentCount(fee)}
              baseFee={fee}
              event_type="generalpost"
              redirectTo="activities"
            />
          </div>
        </div>

        <div className="col-md-4">
          <StarProfileRightContent star_id={star_id} />
        </div>
      </div>
    </div>
  );
}

export default Videos;
